export default __webpack_public_path__ + "static/media/nohalogo.9883fad1.jpeg";